module.exports = __webpack_public_path__ + "img/Logothetis.4f7c3a44.jpg";